import { FoodRequestOptions } from './food-request-options';

export class RecipeFilter extends FoodRequestOptions {
    SectionString: string;
    SubCategory: string;
    RecipeGroup: string;
    BookString: string;
    Category: string;
    CalMin: number;
    CalMax: number;
    PMin: number;
    PMax: number;
    FMin: number;
    FMax: number;
    ChMin: number;
    ChMax: number;
    WordFiltr: string;
    QFiltr: string;
    IsPersonal: string;
    IsUsed: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/recipe-filter-model.ts